/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
import { checkNumber } from '../utilities/utilities';
import {
  selectedIcon,
  deselectedIcon,
  yellowColorWithDeselectedIcon,
  blueColorWithDeselectedIcon,
  pinkColorWithDeselectedIcon,
  greyColorWithDeselectedIcon,
  yellowColorWithSelectedIcon,
  blueColorWithSelectedIcon,
  pinkColorWithSelectedIcon,
  greyColorWithSelectedIcon,
  greenColorWithSelectedIcon,
  greenColorWithDeselectedIcon,
} from './ExportIcon';
import {
  handleCommaSeparatedAmount,
  removeCommaForNumberFiled,
  removeDollarForNumberFiled,
  removeWhiteSpaceForNDC,
} from '../CommonUtilities/commonUtilities';

export const uncheckedMark =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAbCAYAAAAdx42aAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAHZSURBVEhL7ZZZbwIxDIT7//8bAiHEJcSNuO/7dPVZbFWBkwaC4KXzMsRJllln7OyXfBimgOPxKJvNRvl8Pstut5P9fq9zMGPioet8MAVMp1MpFovK2+1WarWadLtdnYMZEw9d54MpYLFYSLVaVeYt2u22DAYDnYMZE/9rXb1el36/L6vVSmMWTAGXy0VOp5Ny8jtJJXw751q3XC6lUChIo9HQmAVTAIpbrZZXeQgOh4MMh0OZzWbXyD1MAePxWLLZrHIMyAJmxKQumALYNJ/Pfxz9LDAg6e/1etfIPUwBGApnwzFgf7PZVCO6YAoYjUaSyWSUY4AxST/mdMEUsF6vpdPpKMcAE1KOZNMFUwDmYXNSUs+CLlkqlfQYXDAFYMBKpaIcA1LPM3yZNAVQt+Vy2Vu/IUAAzYhMuGAKYCMO9pknBPwxL0JTc8FpQi6TWBPSR+gBk8nkGrmHKYDyS6fTLylDsugzsymA9NOGX9GIft+QFkwBlCBXLByD228EC6YAziyXy3nPLgSkniz47hRTAKXDJUI35CjIBI6mp8OMiSd9Ag5ZZ8EUkIAvmnw+r9XAvZ5KpZQZE2f+kXUWvALwAcfAhcJ58lCYMXHmH1lnwSvgHfgX8GEBIt8EVEx6Cv/eTAAAAABJRU5ErkJggg==';
export const checkMark =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAfCAYAAADwbH0HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAQDSURBVEhL7VZJKK5tGH5TEmVYSCRlCCVSQhFFsZCFjUSRUBaGLLBQ2EgpiaysKDIlGYsdsqCMSabM8zzP0/V33f/3nl5fzve9p87pLP7/qrf7Ge7nuZ/nHq7nVfCX8L/h34bz83Nsb2/Lx7Yx/pjhubk59PX1yce2MX6b4dfXV7nZzMwM2tvbUVJSgry8PDQ2Nn5v+O3tDY+Pj6D8+PjA8/MzXl5eZJKSfY6b0nt6esLBwQHGx8dRX1+P1NRUxMXFISkpCc3NzVheXhY9LZSrqyusrKyAkhtsbW3h6OhIJinZ57gpvbW1NXR2diIzMxMxMTGIiIhAeXk5hoaGsLm5ibu7O9HTQrm9vZVJSt5if38fp6enMknJPse/06Pxvb09uVV2djaCg4MRFRWFnJwcDAwMyHrVK8ZQPj8/8f7+Dkq1TVcSlMZz2jYNDw4OiktdXV3h5+eH/Px8ifPJyYmsp+53UO7v7+XUlHpBV6+vr6OlpQUpKSkIDQ1FSEgIioqK0NvbK0lGHVNQLi4usLCwAEo94E0Z2+7ubmRlZcHBwQGBgYHIyMjA8PCwJJkeKIzBzc3NT2NhDB5wdHRUMjcgIAAuLi4oKChAT08PJiYmsLOzY9A0DYWJwkylVPHw8IDDw0MxwhDwliq4eUVFBXx9feHl5YX4+Hi0tbWJwY2NDYmtHiiMx/z8/Bda293dlVKYnp6WDbXxqq6uRlBQEGxtbREdHS0ZzTJjfZNEtIc0BYW3Y1wor6+vMTY2hpqaGiQnJwvz1NXVYXFxUb7+/n4kJibCzc1N3FxYWCjkQI/RKMuHbT1QmPJcRMnarK2tFdaxtraGo6MjIiMjhRyampokrt7e3nB2dpZ2V1eXYRsIq62uroq39EBhYrE0KLmYbmtoaEBsbCw8PDzg6ekpyZOeng53d3cxGhYWJofRGqGLuQc9pwcK3UvKo1QxOzuLyspKYSI7OzuEh4fD398fiqIISeTm5soaLWiY1MjD64HCBcxobVIcHx9jcnISCQkJsLCwgI2NDaysrMRwWlqalM7Z2ZlB+1/QIA9DMtIDSS4SgtZF3IRlwaeNMWW8LS0tJZPpCYbGmJnIAzzw5eWlYcQ0pJz4XmrLSUVra6tksZOTE+zt7eHj44OOjg7D7Feo/K3yvDkIgZAotASiYmRkBGVlZcLFfO5KS0sxNTVlmP0Krte+bOagsJT41FEagzFjPIuLi1FVVSUPvfoGG8P4jTYHhTEhOXwXG25Gb5C9SDIsl+8OSNDFvLVezldYAurGNMKN1eSiZJ/jNEpQ6tEzhx8/e/wNXVpakuxmqfAxp2Sf45z/FT1z+GGYcaa7SfZ0MTejZJ/jnP8VPXP4Y//V5vBfMwz8A98pV66XXgmUAAAAAElFTkSuQmCC';

export default function getDocDefinition(
  printParams,
  agGridApi,
  agGridColumnApi,
  fileName,
  UserDefaultValues,
  hideColumnsInPdf,
  showFooter,
  footerVariableObj,
  info,
  isScrollOn = false,
  defaultColWidth = 100,
  exportOnlyTotal,
  reportName,
  logInUser,
  skipHeaderRow
) {
  const {
    PDF_HEADER_COLOR,
    PDF_INNER_BORDER_COLOR,
    PDF_OUTER_BORDER_COLOR,
    PDF_ODD_BKG_COLOR,
    PDF_EVEN_BKG_COLOR,
    PDF_HEADER_HEIGHT,
    PDF_ROW_HEIGHT,
    PDF_PAGE_ORITENTATION,
    PDF_WITH_CELL_FORMATTING,
    PDF_WITH_COLUMNS_AS_LINKS,
    PDF_SELECTED_ROWS_ONLY,
  } = printParams;

  const {
    firstInfo = '',
    secondInfo = '',
    thirdInfo = '',
    fourthInfo = '',
    fifthInfo = '',
    sixthInfo = '',
    seventhInfo = '',
    eighthInfo = '',
    ninethInfo = '',

    tenthInfo = '',
    checkbox = false,
    getCheckedBoxes = [],
  } = info;
  const pageHeight = 700;

  let firstInfoObj = {
    text: `${firstInfo}`,
    fontSize: 10,
    fontFamily: 'arial',
    alignment: 'left',
  };

  let secondInfoObj = {
    text: `${secondInfo}`,
    fontSize: 10,
    fontFamily: 'arial',
    alignment: 'left',
  };

  if (checkbox) {
    firstInfoObj = {
      columns: [
        {
          width: 'auto',
          text: firstInfo,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'left',
        },
        {
          margin: [5, -2, 0, 0],
          width: 15,
          image: checkMark,
          height: 15,
        },
      ],
    };

    const columns = [];
    const arr = secondInfo.split(' ,');
    for (let i = 0; i < arr.length; i++) {
      columns.push({
        width: 'auto',
        text: `${arr[i]}: `,
        fontSize: 10,
        fontFamily: 'arial',
        alignment: 'left',
      });
      columns.push({
        margin: [10, -2, 3, 0],
        width: 15,
        image: getCheckedBoxes[i] ? checkMark : uncheckedMark,
        height: 15,
      });
    }
    secondInfoObj = {
      columns,
    };
  }
  return (function () {
    const columnGroupsToExport = getColumnGroupsToExport();
    const columnsToExport = getColumnsToExport();
    const widths = getExportedColumnsWidths(columnsToExport);
    const rowsToExport = getRowsToExport(columnsToExport);
    const pinnedBottomRowData = agGridApi.pinnedRowModel.pinnedBottomRows;
    
    let paidTotalCount = 0;
    agGridApi.forEachNodeAfterFilterAndSort((node, index) => {
      if(agGridApi?.rowModel?.rowsToDisplay?.[index]?.data?.providerId==="Paid Date Total:"){
        paidTotalCount++
      }
    })
    let totalRows = pinnedBottomRowData.length
      ? rowsToExport.length -
        (pinnedBottomRowData.length > 1 ? pinnedBottomRowData.length : 1)
      : rowsToExport.length;
    totalRows = totalRows - paidTotalCount;
    const body = columnGroupsToExport
      ? [columnGroupsToExport, columnsToExport, ...rowsToExport]
      : skipHeaderRow
      ? [...rowsToExport]
      : [columnsToExport, ...rowsToExport];
    const topMargin = fifthInfo.length > 0 ? 4 : 24;
    const headerRows = columnGroupsToExport ? 2 : 1;
    const header = (currentPage, pageCount) => {
      let widths = [255, 255, 255];
      if (isScrollOn) {
        const columnsToExport1 = getColumnsToExport();
        const pageWidth = columnsToExport1.length * defaultColWidth - 75;
        widths = [pageWidth / 3, pageWidth / 3, pageWidth / 3];
      }
      return {
        alignment: 'center',
        fontSize: 10,
        margin: [28.8, topMargin, 28.8, 25.92],
        style: 'tableExample',
        table: {
          headerRows: 1,
          widths,
          body: [
            [
              {
                text: `Requested By: ${
                  UserDefaultValues && UserDefaultValues.userId
                    ? UserDefaultValues.userId
                    : logInUser
                }`,
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'left',
              },
              {
                text: `${
                  fileName === undefined ? 'File' : reportName || fileName
                }`,
                fontSize: 12,
                bold: true,
                fontFamily: 'arial',
                alignment: 'center',
                decorationStyle: 'dotted',
              },
              {
                text: `Date Printed: ${moment(new Date()).format(
                  'MM/DD/YYYY'
                )} `,
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'right',
              },
            ],
            [
              firstInfoObj,

              {
                text: `${thirdInfo}`,
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'center',
                bold: true,
              },
              {
                text: `Total Records: ${
                  totalRows == '-1' ? 0 : totalRows?.toLocaleString('en-US')
                } `,
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'right',
              },
            ],
            [
              secondInfoObj,
              {
                text: `${fourthInfo}`,
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'center',
              },
              {
                text: `Page: ${currentPage} of ${pageCount} `,
                fontSize: 10,
                fontFamily: 'arial',
                alignment: 'right',
              },
            ],
            [
              {
                text: `${fifthInfo}`,

                fontSize: 10,

                fontFamily: 'arial',

                alignment: 'left',
              },

              {
                text: `${sixthInfo}`,

                fontSize: 10,

                fontFamily: 'arial',

                alignment: 'center',
              },

              {
                text: `${seventhInfo}`,

                fontSize: 10,

                fontFamily: 'arial',

                alignment: 'right',
              },
            ],

            [
              {
                text: `${eighthInfo}`,

                fontSize: 10,

                fontFamily: 'arial',

                alignment: 'left',
              },

              {
                text: `${ninethInfo}`,

                fontSize: 10,

                fontFamily: 'arial',

                alignment: 'center',
              },

              {
                text: `${tenthInfo}`,

                fontSize: 10,

                fontFamily: 'arial',

                alignment: 'right',
              },
            ],
          ],
        },
        layout: 'noBorders',
      };
    };
     const footer = (currentPage, pageCount) => {
      if (currentPage === pageCount && showFooter) {
        return {
          text: `${footerVariableObj?.name}: $ ${footerVariableObj?.amount} `,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'right',
          marginRight: [25.92],
        };
      }
      return null;
    };
    let topHeaderMargin = 80;
    if (
      firstInfo.length >= 25 ||
      secondInfo.length >= 25 ||
      thirdInfo.length >= 25
    ) {
      topHeaderMargin = 90;
    }
    if (
      fourthInfo.length ||
      fifthInfo.length ||
      sixthInfo.length ||
      seventhInfo.length
    ) {
      topHeaderMargin = 120;
    }

    if (eighthInfo.length || ninethInfo.length || tenthInfo.length) {
      topHeaderMargin = 140;
    }
    const pageMargins = [28.8, topHeaderMargin, 28.8, 25.92];

    const heights = (rowIndex) =>
      rowIndex < headerRows ? PDF_HEADER_HEIGHT : PDF_ROW_HEIGHT;

    const fillColor = (rowIndex, node) => {
      if (rowIndex < node.table.headerRows) {
        return PDF_HEADER_COLOR;
      }
      return rowIndex % 2 === 0 ? PDF_ODD_BKG_COLOR : PDF_EVEN_BKG_COLOR;
    };

    const hLineWidth = (i, node) =>
      i === 0 || i === node.table.body.length ? 1 : 1;

    const vLineWidth = (i, node) =>
      i === 0 || i === node.table.widths.length ? 1 : 0;

    const hLineColor = (i, node) =>
      i === 0 || i === node.table.body.length
        ? PDF_OUTER_BORDER_COLOR
        : PDF_INNER_BORDER_COLOR;

    const vLineColor = (i, node) =>
      i === 0 || i === node.table.widths.length
        ? PDF_OUTER_BORDER_COLOR
        : PDF_INNER_BORDER_COLOR;
    const currentYear = new Date().getFullYear();
    const docDefintiion = {
      pageOrientation: PDF_PAGE_ORITENTATION,
      header,
      //footer,
      content: [
        {
          style: 'myTable',
          table: { headerRows, widths, body, heights },
          // layout: {
          //   fillColor,
          //   hLineWidth,
          //   vLineWidth,
          //   hLineColor,
          //   vLineColor,
          // },
        },
      ],
      styles: {
        myTable: {
          margin: [0, 0, 0, 0],
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          fontFamily: 'arial',
        },
        tableCell: {
          bold: false,
          fontSize: 10,
          fontFamily: 'arial',
        },
      },
      pageSize: {},
      pageMargins,
      //footer: MainFooter
      footer: (currentPage, pageCount) => {
        const items = [];

        const conditionalFooter = (currentPage === pageCount && showFooter)
        ? {
          text: `${footerVariableObj?.name}: $ ${footerVariableObj?.amount} `,
          fontSize: 10,
          fontFamily: 'arial',
          alignment: 'right',
          marginRight: [25.92],
        }
        : null;

        if (conditionalFooter) {
          items.push(conditionalFooter);
        }

        // Main footer (always visible)
        items.push({
        text:`${currentYear} Conduent Business Services, LLC. All rights reserved. Conduent and Conduent Agile Star are trademarks of Conduent Business Services, LLC in the United States and/or other countries.`,
        fontSize: 8,
        color: '#636363',
        fontFamily: 'Arial',
        alignment: 'center',
        margin: items.length > 1 ? [0, 20, 0, 5] : undefined,
        });
        return items;
      }

    };
    if (isScrollOn) {
      const columnsToExport1 = getColumnsToExport();
      docDefintiion.pageSize.height = pageHeight;
      docDefintiion.pageSize.width = columnsToExport1.length * defaultColWidth;
    } else {
      delete docDefintiion.pageSize;
    }
    return docDefintiion;
  })();

  function getColumnGroupsToExport() {
    if (!agGridColumnApi) return null;
    const displayedColumnGroups =
      agGridColumnApi?.getAllDisplayedColumnGroups();

    const isColumnGrouping = displayedColumnGroups.some((col) =>
      col.hasOwnProperty('children')
    );

    if (!isColumnGrouping) {
      return null;
    }

    const columnGroupsToExport = [];

    displayedColumnGroups.forEach((colGroup) => {
      const isColSpanning = colGroup.children.length > 0;
      let numberOfEmptyHeaderCellsToAdd = 0;

      if (isColSpanning) {
        const headerCell = createHeaderCell(colGroup);
        columnGroupsToExport.push(headerCell);
        // subtract 1 as the column group counts as a header
        numberOfEmptyHeaderCellsToAdd--;
      }

      // add an empty header cell now for every column being spanned
      colGroup.displayedChildren.forEach((childCol) => {
        const pdfExportOptions = getPdfExportOptions(childCol.getColId());
        if (!pdfExportOptions || !pdfExportOptions.skipColumn) {
          numberOfEmptyHeaderCellsToAdd++;
        }
      });

      for (let i = 0; i < numberOfEmptyHeaderCellsToAdd; i += 1) {
        columnGroupsToExport.push({});
      }
    });

    return columnGroupsToExport;
  }

  function getColumnsToExport() {
    const columnsToExport = [];
    let colDisplayArray = [];
    const columnDefsData = agGridColumnApi.columnModel?.columnDefs;
    colDisplayArray = agGridColumnApi.getAllDisplayedColumns();
    colDisplayArray = colDisplayArray.map((prop) => {
      prop.field = prop.colDef?.field;
      return prop;
    });
    if (colDisplayArray?.length !== columnDefsData?.length) {
      const newObj = [];
      const isSameUser = (a, b) => a.field === b.field;
      // Get items that only occur in the left array,// using the compareFunction to determine equality.
      const onlyInLeft = (left, right, compareFunction) =>
        left.filter(
          (leftValue) =>
            !right.some((rightValue) => compareFunction(leftValue, rightValue))
        );
      const onlyInA = onlyInLeft(columnDefsData, colDisplayArray, isSameUser);
      const onlyInB = onlyInLeft(colDisplayArray, columnDefsData, isSameUser);
      const result = [...onlyInA, ...onlyInB];
      colDisplayArray.forEach((item) => {
        if (
          !(
            result?.filter((x) => {
              return item?.colDef.hideColumnName === x.field;
            })?.length > 0
          )
        ) {
          newObj.push(item);
        }
      });
      if (newObj?.length > 0) {
        colDisplayArray = newObj;
      }
    }
    if (hideColumnsInPdf && hideColumnsInPdf.length > 0) {
      hideColumnsInPdf.forEach((element) => {
        colDisplayArray = colDisplayArray.filter(
          (item) => item.getColId() !== element
        );
      });
    }
    colDisplayArray.forEach((col) => {
      const pdfExportOptions = getPdfExportOptions(col.getColId());
      if (pdfExportOptions && pdfExportOptions.skipColumn) {
        return;
      }
      const headerCell = createHeaderCell(col);
      columnsToExport.push(headerCell);
    });
    return columnsToExport;
  }

  function getRowsToExport(columnsToExport) {
    const rowsToExport = [];
    const pinnedBottomRowData = agGridApi.pinnedRowModel.pinnedBottomRows;
    // Iterate through all pinned bottom rows
    pinnedBottomRowData.forEach((pinnedRow) => {
      if (exportOnlyTotal === 'Totals') {
        const pinnedRowToExport = columnsToExport.map(({ colId }) => {
          const pinnedRowValue = pinnedRow.data[colId];
          const pinnedTableCell = createTableCell(pinnedRowValue, colId, {
            data: {},
            rowPinned: true,
          });

          // Check if the value contains brackets and format it
          if (
            typeof pinnedRowValue === 'string' &&
            pinnedRowValue.includes('(') &&
            pinnedRowValue.includes(')')
          ) {
            pinnedTableCell.style = {
              ...(pinnedTableCell.style || {}),
              fillColor: '#fff',
              color: 'red', // Set the text color to red
            };
          }

          pinnedTableCell.fillColor = '#fff';
          return pinnedTableCell;
        });
        rowsToExport.push(pinnedRowToExport);
      }
    });

    agGridApi.forEachNodeAfterFilterAndSort((node, index) => {
      if (PDF_SELECTED_ROWS_ONLY && !node.isSelected()) {
        return;
      }
      const rowToExport = columnsToExport.map(({ colId }) => {
        const cellValue = agGridApi.getValue(colId, node);
        const tableCell = createTableCell(cellValue, colId, node);

        return tableCell;
      });
      rowsToExport.push(rowToExport);

      const totalRowLength = agGridApi.rowModel.rowsToDisplay.length - 1;
      if (index === totalRowLength && pinnedBottomRowData.length !== 0) {
        pinnedBottomRowData.forEach((pinnedRow) => {
          const pinnedRowToExport = columnsToExport.map(({ colId }) => {
            const pinnedRowValue = pinnedRow.data[colId];
            let pinnedTableCell = createTableCell(pinnedRowValue, colId, {
              ...node,
              rowPinned: true,
            });
            const col = agGridColumnApi.getColumn(colId);

            if (
              typeof pinnedRowValue === 'string' &&
              pinnedRowValue.includes('(') &&
              pinnedRowValue.includes(')')
            ) {
              pinnedTableCell.style = {
                ...(pinnedTableCell.style || {}),
                fillColor: '#fff',
                color: 'red',
                bold: true,
                fontSize: 10,
              };
            } else {
              if (pinnedTableCell.style) {
                pinnedTableCell = {
                  ...pinnedTableCell,
                  fillColor: '#fff',
                  style: {
                    ...pinnedTableCell.style,
                    fillColor: '#fff',
                    bold: true,
                    fontSize: 10,
                  },
                };
              }
            }

            if (col?.colDef?.showCountValue) {
              pinnedTableCell = {
                ...pinnedTableCell,
                text: rowsToExport.length,
                style: {
                  ...pinnedTableCell.style,
                  alignment: 'right',
                },
              };
            }
            if (col?.colDef?.displayTextOnly) {
              pinnedTableCell = {
                ...pinnedTableCell,
                text: col?.colDef?.displayTextOnly,
              };
            }
            return pinnedRowValue === '' ? '' : pinnedTableCell;
          });
          rowsToExport.push(pinnedRowToExport);
        });
      }
    });
    return rowsToExport;
  }

  function getExportedColumnsWidths(columnsToExport) {
    return columnsToExport.map(() => `${100 / columnsToExport.length}% `);
  }

  function createHeaderCell(col) {
    const headerCell = {};
    const isColGroup = col.hasOwnProperty('children');

    if (isColGroup) {
      headerCell.text =
        col?.originalColumnGroup?.colGroupDef?.headerName ||
        col?.providedColumnGroup?.colGroupDef?.headerName;
      headerCell.colSpan = col.children.length;
      headerCell.colId = col.groupId;
      headerCell.style = {
        alignment: 'center',
        fontSize: 10,
        bold: true,
        fontFamily: 'arial',
      };
    } else {
      let { headerName } = col.colDef;

      if (col.sort) {
        headerName += headerName ? ` (${col.sort})` : '';
      }
      if (col.filterActive) {
        headerName += headerName ? ' [FILTERING]' : '';
      }

      headerCell.text = headerName;
      headerCell.colId = col.getColId();
    }
    if (col.colDef?.columnSpan) {
      headerCell.colSpan = col.colDef?.columnSpan;
    }
    if (!isColGroup) {
      headerCell.style = 'tableHeader';
    }
    return headerCell;
  }
  function numberToColor(val) {
    if (val?.toString() === '16756655' || val?.toString() === 'blue-legend') {
      // blue-legend color
      return '#347DC6';
    }
    if (val?.toString() === '11534335' || val?.toString() === 'yellow-legend') {
      // yellow-legend color
      return '#f1f511';
    }
    if (val?.toString() === '11513855' || val?.toString() === 'pink-legend') {
      // pink-legend color
      return '#F7B3BC';
    }
    if (val?.toString() === '12632256' || val?.toString() === 'grey-legend') {
      // grey-legend color
      return '#d4d4d4';
    }
    if (val?.toString() === '00b300' || val?.toString() === 'green-legend') {
      // green-legend color
      return '#a0c0a0';
    }
    return '#fff'; // white-legend color
  }

  function createTableCell(cellValue, colId, node) {
    const col = agGridColumnApi.getColumn(colId);
    let isNegativeVal = false;
    let colorCode = '';
    let dropDownVal = '';
    let alignRight = col.colDef.dataAlignRight ?? false;
    if (
      col.colDef.isTextColorRed &&
      cellValue &&
      cellValue?.toString()?.trim() !== ''
    ) {
      alignRight = true;
      const numberVal = removeCommaForNumberFiled(cellValue || 0);
      isNegativeVal = cellValue?.toString()?.includes('$')
        ? !isNaN(numberVal?.toString().split('$')[1]) &&
          !(parseFloat(numberVal?.toString().split('$')[1]) >= 0)
        : !isNaN(numberVal) && !(parseFloat(numberVal) >= 0);
    }
    if (col.colDef.removeWhiteSpaceForNDC && colId === 'ndc') {
      if(node?.rowPinned){
        return {
          text:''
        }
      }
      cellValue = removeWhiteSpaceForNDC(cellValue || 0);
    }
    if(col.colDef.removeuuidNDC && colId === 'ndc' && !node?.rowPinned){
      cellValue = ' '
    }
    if(col.colDef.removeuuidNDC && colId === 'ndc' && !node?.rowPinned){
      if(node?.rowPinned){
        return {
          text:''
        }
      }
      cellValue = ' '
    }
    if(col.colDef.removeuuidNDC && colId === 'ndc'){
      cellValue = ' '
    }
    if (col.colDef.isAmount && checkNumber(cellValue || 0)) {
      alignRight = true;
      cellValue = Math.round(100 * cellValue) / 100;
    }
    if (col.colDef.exportZeroesTwo) {
      alignRight = true;
      if (checkNumber(cellValue || 0)) {
        cellValue = parseFloat(
          cellValue?.toString()?.replace(',', '')?.trim() || 0
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } else {
        cellValue = ' 0.00';
      }
    }
    if (col.colDef.exportZeroesThree) {
      if (checkNumber(cellValue)) {
        cellValue = parseFloat(
          cellValue?.toString()?.replace(',', '')?.trim()
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        });
      } else {
        cellValue = '0.000';
      }
    }
    if (col.colDef.exportZeroesFour) {
      alignRight = true;
      if (checkNumber(cellValue)) {
        cellValue = parseFloat(
          cellValue?.toString()?.replace(',', '').trim()
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        });
      } else {
        cellValue = '0.0000';
      }
    }
    if (col.colDef.exportZeroesSix) {
      alignRight = true;
      if(node?.rowPinned && cellValue === 'Totals:'){
        cellValue= 'Totals:'
      }
      else if (checkNumber(cellValue)) {
        cellValue = parseFloat(
          cellValue?.toString()?.replace(',', '').trim()
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 6,
          maximumFractionDigits: 6,
        });
      } else {
        cellValue = '0.000000';
      }
    }

    if (col.colDef?.exportZeroesOne) {
      if (checkNumber(cellValue)) {
        cellValue = parseFloat(
          cellValue?.toString()?.replace(',', '').trim()
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        });
      } else {
        cellValue = '0.0';
      }
    }
    if (col.colDef.exportZeroSix) {
      alignRight = true;
      if(node?.rowPinned && cellValue === 'Totals:'){
        cellValue= 'Totals:'
      }
     else if (checkNumber(cellValue)) {
        cellValue = parseFloat(
          cellValue?.toString()?.replace(',', '').trim()
        )?.toLocaleString('en-US', {
          minimumFractionDigits: 6,
          maximumFractionDigits: 6,
        });
      } else {
        cellValue = '0t';
      }
    }
    if (
      (colId === 'adjustedUnitRebateAmt' ||
        colId === 'adjustedUnits' ||
        colId === 'currUnitsDisputed') &&
      !checkNumber(cellValue) && !node?.rowPinned
    ) {
      cellValue = '';
    }

    if (
      col.colDef.valueFormatter &&
      col.colDef.exportOption?.enableValueFormatter
    ) {
      const formattedValue = col.colDef.valueFormatter({
        node,
        value: cellValue,
        data: node.data,
      });
      cellValue = formattedValue;
    }
    if (col.colDef.showBackgroundColor) {
      colorCode = numberToColor(node?.data[col.colDef.fillBackgroundColorCol]);
    }
    if (col.colDef.showDropDownVal) {
      dropDownVal = node?.data[col.colDef.dropDownValueCol];
    }
    let pass = 0;
    if (
      (pass === 0 || pass === 1) &&
      (col.colDef.field === 'emailAdd' || col.colDef.field === 'sendFlag')
    ) {
      pass++;
    }
    if (
      !cellValue?.toString()?.includes('(') &&
      (cellValue?.toString()?.includes('$') ||
        col.colDef.exportOption?.printWithCurrency) &&
      cellValue
    ) {
      alignRight = true;
      const formattedValue = removeDollarForNumberFiled(cellValue || 0)?.trim();
      cellValue = handleCommaSeparatedAmount(
        cellValue?.toString()?.includes('$') ? formattedValue : cellValue
      );
    } else if (
      cellValue?.toString()?.includes(')') &&
      cellValue?.toString()?.includes('(') &&
      (cellValue?.toString()?.includes('$') ||
        col.colDef.exportOption?.printWithCurrency) &&
      (alignRight || col.colDef.cellStyle?.textAlign === 'right') &&
      cellValue
    ) {
      const dollarVal = removeDollarForNumberFiled(cellValue || 0)?.trim();
      const dollarVal1 = dollarVal?.split('(')[1]?.trim();
      const value = dollarVal1?.split(')')[0]?.trim();
      cellValue = `(${handleCommaSeparatedAmount(value)})`;
    }
    if (col.colDef.showCheckboxIcon && col.colDef.showCountValue) {
      cellValue = node?.data[colId?.trim()];
    }
    if(col.colDef.showCheckboxIcon && node?.rowPinned){
      return {
        text:'',
      }
    }
    const tableCell =
      (parseInt(cellValue, [0, 1]) === 1 ||
        cellValue?.toString() === 'true' ||
        cellValue?.toString() === 'Valid') &&
      col.colDef.showCheckboxIcon
        ? {
            svg:
              colorCode === '#f1f511'
                ? yellowColorWithSelectedIcon
                : colorCode === '#347DC6'
                ? blueColorWithSelectedIcon
                : colorCode === '#F7B3BC'
                ? pinkColorWithSelectedIcon
                : colorCode === '#545955'
                ? greyColorWithSelectedIcon
                : colorCode === '#a0c0a0'
                ? greenColorWithSelectedIcon
                : selectedIcon,
            width: 12,
            height: 12,
          }
        : col.colDef.showCheckboxIcon && !node?.rowPinned &&
          (parseInt(cellValue, [0, 1]) === 0 ||
            cellValue?.toString() === 'false' ||
            cellValue?.toString() === 'Invalid')
        ? {
            svg:
              colorCode === '#f1f511'
                ? yellowColorWithDeselectedIcon
                : colorCode === '#347DC6'
                ? blueColorWithDeselectedIcon
                : colorCode === '#F7B3BC'
                ? pinkColorWithDeselectedIcon
                : colorCode === '#545955'
                ? greyColorWithDeselectedIcon
                : colorCode === '#a0c0a0'
                ? greenColorWithDeselectedIcon
                : deselectedIcon,

            width: 12,
            height: 12,
          }
        : col.colDef.isBgColor && col.colDef.bgColorName && cellValue
        ? {
            text:
              (isNegativeVal && cellValue
                ? `(${
                    col.colDef.printPrefixValue
                      ? col.colDef.printPrefixValue
                      : ''
                  } ${cellValue?.toString()?.replace('-', '')?.trim()} ${
                    col.colDef.printPostfixValue
                      ? col.colDef.printPostfixValue
                      : ''
                  })`
                : `${
                    col.colDef.printPrefixValue
                      ? col.colDef.printPrefixValue
                      : ''
                  }${
                    col.colDef.showDropDownVal
                      ? dropDownVal !== undefined && dropDownVal !== null
                        ? dropDownVal
                        : ''
                      : cellValue
                  } ${
                    col.colDef.printPostfixValue
                      ? col.colDef.printPostfixValue
                      : ''
                  }`) || 'export',
            style: {
              ...tableCell,
              fontSize: 10,
              color: isNegativeVal ? 'red' : '',
              alignment: alignRight ? 'right' : 'left',
              fillColor: numberToColor(node?.data[col.colDef.bgColorName]),
            },
          }
        : col.colDef.isTextColorRed && cellValue
        ? {
            text: isNegativeVal
              ? `(${
                  col.colDef.printPrefixValue ? col.colDef.printPrefixValue : ''
                } ${cellValue?.toString()?.replace('-', '').trim()}${
                  col.colDef.printPostfixValue
                    ? col.colDef.printPostfixValue
                    : ''
                })`
              : cellValue?.toString()?.includes('%')
              ? `${cellValue}`
              : `${
                  col.colDef.printPrefixValue ? col.colDef.printPrefixValue : ''
                } ${
                  col.colDef.printPrefixValue?.includes('$')
                    ? cellValue?.toLocaleString('en-US')
                    : cellValue?.toLocaleString('en-US')
                }${
                  col.colDef.printPostfixValue
                    ? col.colDef.printPostfixValue
                    : ''
                }`,
            style: {
              ...tableCell,
              fontSize: 10,
              color: isNegativeVal ? 'red' : '',
              alignment: alignRight ? 'right' : 'left',
              fillColor: numberToColor(node?.data[col.colDef.bgColorName]),
            },
          }
        : col.colDef.showDropDownVal
        ? {
            text:
              dropDownVal !== undefined && dropDownVal !== null
                ? dropDownVal
                : '',
            style: { ...tableCell, fontSize: 10 },
          }
        : {
            text:
              cellValue !== undefined &&
              cellValue !== 'Invalid date' &&
              cellValue !== null &&
              cellValue !== '-1'
                ? `${
                    col.colDef.printPrefixValue
                      ? col.colDef.printPrefixValue
                      : ''
                  } ${
                    cellValue !== undefined &&
                    cellValue !== 'Invalid date' &&
                    cellValue !== null &&
                    cellValue !== '-1'
                      ? col.colDef.printPrefixValue?.includes('$')
                        ? cellValue?.toLocaleString('en-US')
                        : cellValue
                      : ''
                  }`
                : '',
            style: {
              ...tableCell,
              fillColor: numberToColor(node?.data[col.colDef.bgColorName]),
              fontSize: 10,
            },
          };

    const printWithCurrency = col.colDef.exportOption?.printWithCurrency;
    if (printWithCurrency) {
      const isIncludeCurrency = tableCell.text
        ?.toString()
        ?.includes(printWithCurrency);
      if (
        !isIncludeCurrency &&
        (cellValue || cellValue === 0) &&
        !isNaN(cellValue?.toString()?.replace(',', '')?.trim())
      ) {
        if (isNegativeVal)
          tableCell.text = `${tableCell.text.slice(
            0,
            1
          )}${printWithCurrency}${tableCell.text.slice(1)}`;
        else tableCell.text = `${printWithCurrency} ${tableCell.text}`;
      }
    }
    if (
      !tableCell.text?.toString()?.includes('(') &&
      (alignRight || col.colDef.cellStyle?.textAlign === 'right') &&
      tableCell.text?.toString()?.includes('$')
    ) {
      if (tableCell?.style?.alignment) tableCell.style.alignment = 'right';
      if (tableCell.text?.toString()?.includes('$')) {
        const formattedValue = removeDollarForNumberFiled(
          tableCell.text
        )?.trim();
        tableCell.text = handleCommaSeparatedAmount(formattedValue);
      }
    } else if (
      tableCell.text?.toString()?.includes('(') &&
      tableCell.text?.toString()?.includes(')') &&
      tableCell.text?.toString()?.includes('$') &&
      (alignRight || col.colDef.cellStyle?.textAlign === 'right')
    ) {
      const amountVal = removeDollarForNumberFiled(tableCell.text)?.trim();
      const dollarVal = amountVal?.split('(')[1]?.trim();
      const formattedValue = dollarVal?.split(')')[0]?.trim();
      tableCell.text = `(${handleCommaSeparatedAmount(formattedValue)})`;
    }

    if (
      (alignRight ||
        col.colDef.cellStyle?.textAlign === 'right' ||
        col.colDef.cellStyle?.dataAlignRight) &&
      !col.colDef.showCheckboxIcon
    ) {
      tableCell.style = { ...tableCell.style, alignment: 'right' };
    }
    if (col.colDef?.columnSpan) {
      tableCell.colSpan = col.colDef?.columnSpan;
    }

   


      const colField = col?.colDef?.field || col?.getColId?.();
      if (
        node &&
        node.data &&
        node.data?.providerId === 'Paid Date Total:' &&
        colField === 'providerId'
      ) {
        tableCell.style = {
          ...tableCell.style,
          bold: true,
          color: '#000000',
          fontSize: 10,
        };
      }

    return tableCell;
  }

  function getPdfExportOptions(colId) {
    const col = agGridColumnApi.getColumn(colId);
    return col.colDef.pdfExportOptions;
  }
}
